// 대리구매 주력 기간 동안 잠시 숨겨둔 기능들.
// 페이지·라우트·API는 그대로 살아 있으므로 true로 바꾸면 바로 복구된다.

/** 헤더의 Products / Limited-Time 메뉴 */
export const SHOW_CATALOG_NAV = false;

/** 홈 하단의 Products 섹션 (카테고리 바 + 상품 그리드) */
export const SHOW_HOME_PRODUCTS = false;

/** 홈 하단의 Limited-Time 섹션 (한정판매) */
export const SHOW_HOME_LIMITED_TIME = false;

/** 헤더의 Event 메뉴 */
export const SHOW_EVENTS = false;

/** 이벤트 목록의 Welcome Coupon — 쿠폰이 대리구매엔 적용되지 않아 노출만 내림 */
export const SHOW_WELCOME_COUPON = false;
